import React, { useContext } from 'react'

import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Icon
} from '@clientbase/clientbase-library'
import { Box, Typography } from '@mui/material'
import Link from 'next/link'

import { formatCpfCnpj, formatPhone } from 'utils'

import { NegativationContext } from '../../context'
import { renderTitle } from '../utils'
import { S } from './'

const PayerDetails: React.FC = () => {
  const { negativation } = useContext(NegativationContext)
  return (
    <Accordion defaultExpanded sx={{ my: 2 }}>
      <AccordionSummary aria-controls="payerDetails-content" id="payerDetails">
        {renderTitle('Detalhes do pagador', 'supervisorAccount')}
      </AccordionSummary>
      <AccordionDetails>
        <div>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin="10px 0px 10px 0px"
          >
            <Typography variant="smLight" color="#777777">
              Nome
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              <Link
                href={`/clientes/${negativation?.customer?.uuid}`}
                target="_blank"
                style={{ textDecoration: 'none' }}
              >
                <Box
                  display="flex"
                  flexWrap="wrap"
                  gap="8px"
                  alignItems="center"
                >
                  <S.Link>{negativation?.customer?.name}</S.Link>
                  <Icon
                    icon="open"
                    width="21px"
                    height="21px"
                    ml="6px"
                    sx={{ cursor: 'pointer', color: '#CBCBCB' }}
                  />
                </Box>
              </Link>
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            <Typography variant="smLight" color="#777777">
              CPF/CNPJ
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {formatCpfCnpj(negativation?.customer?.document || '')}
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            <Typography variant="smLight" color="#777777">
              E-mail
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {negativation?.customer?.email}
            </Typography>
          </Box>
          <Box
            display="flex"
            gap={1.25}
            alignItems="end"
            margin={'10px 0px 10px 0px'}
          >
            <Typography variant="smLight" color="#777777">
              Telefone
            </Typography>
            <S.Separator sx={{ marginTop: '4px' }} />
            <Typography variant="smBold" display="flex" alignItems="center">
              {formatPhone(negativation?.customer?.phone || '')}
            </Typography>
          </Box>
        </div>
      </AccordionDetails>
    </Accordion>
  )
}

export default PayerDetails
